import { useQuery } from "@tanstack/react-query";
import React from "react";

interface Props {
  src: string;
  width: number;
  height: number;
  fallback: JSX.Element;
}

const CachedSignedDocument = (props: Props) => {
  const actualUrl = props.src.split("?")[0];

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: ["cached-signed-document", actualUrl],
    queryFn: async () => {
      const response = await fetch(props.src);
      const blob = await response.blob();
      return URL.createObjectURL(blob);
    },
    staleTime: Infinity,
  });

  if (query.isLoading) {
    return props.fallback;
  }

  if (query.error) {
    return props.fallback;
  }

  if (query.data !== undefined) {
    return <embed src={query.data} width={props.width} height={props.height}></embed>;
  }

  return null;
};

export default CachedSignedDocument;
